const detailViewReducer = (state = {viewName: '', id: -1, isOpen: false}, action) => {
  switch (action.type) {
  case 'SHOW_DETAIL_VIEW': {
    state = {...state, viewName: action.payload.viewName, id: action.payload.id, isOpen: true};
    break;
  }
  case 'HIDE_DETAIL_VIEW': {
    state = {...state, viewName: '', id: -1, isOpen: false};
    break;
  }
  default: {
    break;
  }
  }
  return state;
};

export default detailViewReducer;



// WEBPACK FOOTER //
// ./src/reducers/detailViewReducer.js